<template>
  <el-tree ref="tree" v-bind="Props" :current-node-key="currentKey" :default-expanded-keys="expandedKeys"
    v-on="listeners" @node-click="currentChange" @node-expand="nodeExpand" @node-collapse="nodeCollapse">
    <div slot-scope="{node,data}">
      <slot :node="node" :data="data"> </slot>
    </div>
  </el-tree>
</template>
<style scoped></style>

<script>
  import GhTree from "./ghTree.ts";
  export default GhTree;
</script>